module.exports = __webpack_public_path__ + "logo.476889ee.png";